import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from "@angular/core";

@Directive({
    standalone: false,
    selector: "[commentExpander]",
})
export class CommentExpanderDirective implements OnInit {
    expanded: boolean = false;
    @Input() comment: string;

    constructor(private el: ElementRef, private renderer2: Renderer2) {}
    ngOnInit(): void {
        if (this.comment.length > 25) {
            this.renderer2.setProperty(
                this.el.nativeElement,
                "innerHTML",
                this.comment.slice(0, 25) + "..." + '<span class="text-primary pointer ml-2 toggle-comment cursor-pointer">See more</span>'
            );
        } else {
            this.renderer2.setProperty(this.el.nativeElement, "innerHTML", this.comment);
        }
    }

    @HostListener("click", ["$event"]) toggleComment(event: Event) {
        if (this.comment.length <= 25 || !(event.target as HTMLElement).classList.contains("toggle-comment")) return;
        if (!this.expanded) {
            this.renderer2.setProperty(
                this.el.nativeElement,
                "innerHTML",
                this.comment + '<span class="text-primary pointer ml-2 toggle-comment cursor-pointer">See less</span>'
            );
        } else {
            this.renderer2.setProperty(
                this.el.nativeElement,
                "innerHTML",
                this.comment.slice(0, 25) + "..." + '<span class="text-primary pointer ml-2 toggle-comment cursor-pointer">See more</span>'
            );
        }
        this.expanded = !this.expanded;
    }
}
